import { Stack, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Root = styled(Stack)(({ theme }) => ({
  flexDirection: "row",
  alignItems: "center",
  gap: theme.spacing(0.5),
  color: theme.palette.text.secondary,

  "& .MuiSvgIcon-root": {
    fontSize: 14,
  },
}));

export const Label = styled(Typography)(({ theme }) => ({
  fontSize: 13,
  color: theme.palette.text.secondary,
}));
